import { Directive, HostListener, NgModule, ElementRef } from "@angular/core";
import { Dropdown, DropdownModule } from "primeng/dropdown";

// inputMask

@Directive({
    selector: "p-dropdown[customDropDown]",
})
export class CustomDropDownDirective {
    constructor(private host: Dropdown,
        private el: ElementRef) {
    }

    @HostListener('onFocus') onFocus() {
        //this.host.containerViewChild.nativeElement.style.backgroundColor = "yellow";
        //this.host.el.nativeElement.style.border = "2px solid yellow";
        //this.host.overlay.style.backgroundColor = "2px solid yellow";
      }
    @HostListener('onBlur') onBlur() {
        //this.host.el.nativeElement.style.border = "none";
    }

}

@NgModule({
    imports: [
        DropdownModule
    ],
    declarations: [
        CustomDropDownDirective
    ],
    exports: [
        CustomDropDownDirective
    ]
})

export class CustomDropDownModule {

}
